import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

function NoPermission(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    console.log("no permission -> back to home")
    history.push("/");
    // dispatch({ type: 'users/logout' });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div style={{ marginTop: '100px' }}>403 Forbidden</div>;
}
export default NoPermission;
